import { render } from "./Alignment.vue?vue&type=template&id=1856a188&scoped=true"
import script from "./Alignment.vue?vue&type=script&lang=ts"
export * from "./Alignment.vue?vue&type=script&lang=ts"

import "./Alignment.vue?vue&type=style&index=0&id=1856a188&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1856a188"

export default script